import React from "react"
import { Alert, AlertIcon, AlertText } from "../Alert"
import { Icon } from "../Icons"

interface MasterKeyWarningProps {
  children?: React.ReactNode
  className?: string
}

export const MasterKeyWarning: React.FC<MasterKeyWarningProps> = ({
  children,
  className = "mb-5",
}) => {
  return (
    <Alert action="warning" className={className}>
      <AlertIcon>
        <Icon name="exclamation-circle" className="w-20 h-20" />
      </AlertIcon>
      <AlertText size="xs" bold>
        {children ||
          "Your master key is used to encrypt your data. Keep it safe and don't forget it - it cannot be recovered if lost!"}
      </AlertText>
    </Alert>
  )
}
